import {
  isRouteErrorResponse,
  useNavigate,
  useRouteError,
} from "react-router-dom";
import { PagesRoutes } from "../pages.routes";

/**
 * Router Error Element Component
 *
 * Global error handler for React Router errors
 * Handles route errors and displays appropriate error pages
 * Used To Handle Application Errors from the route pages like 404 pages or any other client errors
 */
export function RouterErrorElement() {
  const error = useRouteError();
  const navigate = useNavigate();

  // Determine error status and message
  let status = 500;
  let message = "An unexpected error occurred";
  console.log(error);

  if (isRouteErrorResponse(error)) {
    status = error.status || 404;
    message = error.statusText || error.data?.message || "Page not found";
  } else if (error instanceof Error) {
    message = error.message;
  }

  // Default error page for other status codes
  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-4">
      <div className="max-w-md w-full text-center">
        <h1 className="text-4xl font-bold mb-4">{status}</h1>
        <p className="text-lg mb-2">Something went wrong</p>
        <p className="text-sm text-muted-foreground mb-6">{message}</p>
        {import.meta.env.DEV && (
          <details className="mb-6 text-left">
            <summary className="cursor-pointer text-sm font-semibold mb-2">
              Error Details (Dev Only)
            </summary>
            <pre className="text-xs bg-muted p-4 rounded overflow-auto">
              {error instanceof Error
                ? error.stack
                : typeof error === "object" && error !== null
                  ? JSON.stringify(error, null, 2)
                  : String(error)}
            </pre>
          </details>
        )}
        <div className="flex gap-4 justify-center">
          <button
            onClick={() => {
              window.location.reload();
            }}
            className="px-6 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors"
          >
            Retry
          </button>
          <button
            onClick={() => {
              navigate(-1);
            }}
            className="px-6 py-2 bg-secondary text-secondary-foreground rounded-md hover:bg-secondary/90 transition-colors"
          >
            Go Back
          </button>
          <button
            onClick={() => {
              navigate(PagesRoutes.home.index);
            }}
            className="px-6 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors"
          >
            Go Home
          </button>
        </div>
      </div>
    </div>
  );
}
